import styled from 'styled-components'
import { Alert, AlertProps, FormControlLabel, Typography } from '@mui/material'
import { LoadingButton } from '@mui/lab'

export const LoginPageWrapper = styled.div`
  width: 100%;
  height: 100%;
  @media (min-width: 600px) {
    background: ${(p) => p.theme.palette.background.default};
  }
`

export const LoginFormWrapper = styled.div`
  margin: auto;
  max-width: calc(400px - 4rem);
  box-sizing: border-box;
  background: ${(p) => p.theme.palette.background.paper};

  padding: 3rem 1rem 3rem 1rem;

  @media (min-width: 600px) {
    max-width: 400px;
    padding: 3rem;
  }

  & form > .MuiFormControl-root {
    margin-top: 1.5rem;
  }
`

export const LogoWrapper = styled.div`
  display: block;
  margin: auto;
  text-align: center;
  width: 130px;

  margin-bottom: 0.5rem;
`

export const LoginTitle = styled(Typography)`
  margin-bottom: 1rem;
`

export const RememberMeInput = styled(FormControlLabel)`
  margin-top: 0.5rem;

  & .MuiFormControlLabel-label {
    color: ${(p) => p.theme.palette.text.secondary};
    font-size: 0.8rem;
  }
`

export const LoginButton = styled(LoadingButton)`
  font-weight: 600;

  margin-top: 1.5rem;
`

// $hidden is a transient prop (not forwarded to the DOM — a real `hidden`
// attribute would mean display:none and collapse the reserved height).
// visibility keeps the layout height and hides the alert from screen readers.
export const ErrorAlert = styled(Alert).attrs({ severity: 'error' })<
  AlertProps & { $hidden: boolean }
>`
  visibility: ${(p) => (p.$hidden ? 'hidden' : 'visible')};
  padding-top: 0;
  padding-bottom: 0;

  font-size: 0.75rem;
  & > .MuiAlert-icon {
    font-size: 1.1rem;
  }
`

export const FinePrint = styled(Typography)`
  margin-top: ${(p) => p.theme.spacing(1)};

  text-align: center;
  font-size: 0.8rem;
  color: ${(p) => p.theme.palette.text.secondary};

  & button {
    color: ${(p) => `${p.theme.palette.text.secondary}B2`};
    text-decoration: underline;
  }

  & button:hover {
    color: ${(p) => `${p.theme.palette.text.secondary}E6`};
  }
`
